import { useEffect } from "react";
import { useInfiniteQuery, useQueryClient } from "react-query";
import { fetchSyncStatus } from "@/services/outbound";
/** Builds the query string for the page after the given response, or undefined when none. */
function nextPageQuery(lastPage) {
  return lastPage.has_next ? "?page=".concat(lastPage.page + 1) : undefined;
}

/**
 * Infinite-query hook paging through outbound sync submissions, enabled on demand.
 * Cached pages are dropped once disabled so each reopen starts fresh from page one
 * instead of refetching every previously loaded page at once.
 */
export function useSyncStatus(workspaceId, patientId, enabled) {
  var queryClient = useQueryClient();
  var queryKey = ["outbound-sync-status", workspaceId, patientId];
  var query = useInfiniteQuery(queryKey, function (_ref) {
    var pageParam = _ref.pageParam;
    return fetchSyncStatus(workspaceId, patientId, pageParam);
  }, {
    enabled: enabled && Boolean(workspaceId && patientId),
    getNextPageParam: nextPageQuery
  });
  useEffect(function () {
    if (!enabled) queryClient.removeQueries(["outbound-sync-status", workspaceId, patientId]);
  }, [enabled, queryClient, workspaceId, patientId]);
  return query;
}